// extracted by mini-css-extract-plugin
export default {"bar":"styles_bar__zllD3","user":"styles_user__wp7Yn"};